import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { addressId: String, addressLabel: String }

  connect() {
    this.updateDropdownLabel()
  }

  updateDropdownLabel() {
    const option = document.querySelector(`option[value="${this.addressIdValue}"]`)
    if (option) {
      const prefix = option.text.match(/^\[.*?\]\s*/)?.[0] ?? ''
      option.text = `${prefix}${this.addressLabelValue}`
    }
  }
}
